import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation  } from 'react-i18next';
import * as ViewManagementModule from 'Modules/ViewManagementModule';

type ConnectedP = {
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
};
type DispatchedP = {
    t?: (key: string) => string;
    hidePopup: () => Function;
};
type P = {
    //
};
type S = {
    //
};
class Popup extends React.Component<P & ConnectedP & DispatchedP, S> {
    constructor(props: P & ConnectedP & DispatchedP) {
        super(props);
    }
    private async handleConfirmation() {
        const { hidePopup } = this.props;
        const { popupData } = this.props.viewManagementStore;
        await popupData.confirmCallback();
        hidePopup();
    }
    public render() {
        const {
            viewManagementStore: { popupData, popupVisible },
            hidePopup,
            t
        } = this.props;
        if (popupVisible) {
            return (
                <div className="popup">
                    <div className="popup__bg" />
                    <div className="popup__inner">
                        <div className="popup__header">
                            {
                              popupData.icon?<img src={`${popupData.icon}`} alt="" />:<img src={`/images/icons/garbage.svg`} alt="" />
                            }
                            <span className="bold">{t(`${popupData.type}`)}</span>
                        </div>
                        <div className="popup__description">
                            <p>{t(`${popupData.type}__description`)}</p>
                            {
                               popupData.extraContent?popupData.extraContent:<p>{t(`cannotUndo`)}</p>
                            }                
                        </div>
                        <div className="popup__buttons">
                            {
                                popupData.template != ViewManagementModule.VMEnumTypes.PopupTemplate.OK_TEMPLATE &&
                                <button className="btn btn--clean" onClick={() => hidePopup()}>
                                    {t('cancel')}
                                </button>
                            }

                            <button className="btn btn--black" onClick={() => this.handleConfirmation()}>
                                {t(`${popupData.type}__confirmation`)}
                            </button>
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}

function mapStateToProps(state: any): ConnectedP {
    return {
        viewManagementStore: state.viewManagementStore
    };
}
function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        hidePopup: () => dispatch(ViewManagementModule.Actions.hidePopup())
    };
}
export default withTranslation (['popup'])(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(Popup) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Layout/Popup/Popup.tsx